// extracted by mini-css-extract-plugin
module.exports = {"home__slider__wrapper":"AdvertismentSlider_home__slider__wrapper__12znt","bullet":"AdvertismentSlider_bullet__1MNOe","bullet_active":"AdvertismentSlider_bullet_active__yi32t"};